import { render, staticRenderFns } from "./ver_musrenbang_pokir.vue?vue&type=template&id=ed401292&"
import script from "./ver_musrenbang_pokir.vue?vue&type=script&lang=js&"
export * from "./ver_musrenbang_pokir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports